import { BaseApi } from '@/api/baseApi';
import { ApiContentType } from '@/types/api';
import { TSendListItem } from '@/types/sendList';

export type TGetListRequest = {
    eid?: number
}

type TMakeListReq = {
    eid: number
    file: File
}

export class SendList extends BaseApi {
    public async getList(data: TGetListRequest | undefined): Promise<TSendListItem[]> {
        return await this.get<TSendListItem[], TGetListRequest>('', data);
    }

    public async makeMessage(data: TMakeListReq): Promise<void> {
        return await this.put('', data, { 'Content-Type': ApiContentType.MultipartFormData });
    }
}
